import classNames from 'classnames'
import imgClocks from 'legacy/lut/assets/img/icon-hour.png'
import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { BusinessTime } from './businessTime/BusinessTime'

import styles from './BusinessHours.module.scss'

interface IProps {
  currentDay: any
  setCurrentDay: (arg0: any) => void
  currentCompany: any
  noData: any
  className?: string
  editable?: boolean
  handleCloseEdit: (isChanged: boolean, item: any) => void
}

interface IBusinessDay {
  day: string
  fromHour: string
  fromMinute: string
  toHour: string
  toMinute: string
  isClosed: boolean
}

const unpackBusinessHours = (item: any) => {
  if (item) {
    const value = (item.Hours || '').replace(/"/g, '').replace('[', '').replace(']', '').split(',')
    const result: IBusinessDay[] = []
    for (const item of value) {
      if (item !== '') {
        const parts = item.split('|')
        const day = parts[0]
        const timeparts = parts[1].split('-')
        const fromTime = timeparts[0].split(':')
        const toTime = (timeparts.length == 2 && timeparts[1].split(':')) || null
        result.push({
          day: day,
          fromHour: fromTime[0] === 'C' ? '00' : fromTime[0],
          fromMinute: fromTime[1] || '',
          toHour: (toTime && toTime[0]) || '',
          toMinute: (toTime && toTime[1]) || '',
          isClosed: fromTime[0] === 'C',
        })
      }
    }
    return result
  }
  return []
}

const BusinessHours = (props: IProps) => {
  const { noData, currentDay, setCurrentDay, currentCompany, className } = props
  if (noData || !currentCompany) {
    return (
      <ul className={styles.list}>
        <Translation text={'partner-preview-empty'} />
      </ul>
    )
  }
  const result: any = []
  if (!currentCompany.Hours) {
    return (
      <ul className={styles.list}>
        <Translation text={'partner-preview-empty'} />
      </ul>
    )
  }
  result.push(
    <div key={'-1'} className={styles.businessDay}>
      <div className={styles.businessDay__day} />
      <div className={styles['businessDay__time-wrap']}>
        <div className={styles.businessDay__title}>
          <Translation text={'partnerpreview-open'} />
        </div>
        <div className={styles.businessDay__title}>
          <Translation text={'partnerpreview-closed'} />
        </div>
      </div>
    </div>
  )

  const formatHours = (hours: string) => {
    if (hours.indexOf('0') === 0) {
      return hours.replace('0', '')
    }
    return hours
  }
  const itemArray = unpackBusinessHours(currentCompany)
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  let timer: any
  const updateTime = (index: number, obj: IObjectAny) => {
    itemArray[index].fromHour = obj.from.split(':')[0]
    itemArray[index].fromMinute = obj.from.split(':')[1]
    itemArray[index].toHour = obj.to.split(':')[0]
    itemArray[index].toMinute = obj.to.split(':')[1]
    itemArray[index].isClosed = obj.isClosed
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(async () => {
      let result = ''
      const daysUsed = []
      for (const value of itemArray) {
        result +=
          daysUsed.findIndex((el) => el === value.day) === -1 &&
          days.findIndex((el) => el === value.day) > -1
            ? value.isClosed
              ? `"${value.day}|C",`
              : `"${value.day}|${formatHours(value.fromHour)}:${value.fromMinute}-${formatHours(
                  value.toHour
                )}:${value.toMinute}",`
            : ''
        value.day && daysUsed.push(value.day)
      }
      result = result !== '' ? `[${result}]` : ''
      currentCompany['Hours'] = result
      await props.handleCloseEdit(true, currentCompany)
    }, 1000)
  }

  const date = new Date()
  const month = date.getMonth() + 1 > 9 ? `${date.getMonth() + 1}` : `0${date.getMonth() + 1}`
  const day = date.getDate() > 9 ? `${date.getDate()}` : `0${date.getDate()}`
  const currDate = `${month}-${day}-${date.getFullYear()}`
  const currDay = date.getDay()
  let currIndex = -1
  for (let i = 0; i < itemArray.length; i++) {
    const itemDay = itemArray[i].day
    if (itemDay === days[currDay] || itemDay === currDate) {
      currIndex = i
    }
    result.push(
      <BusinessTime
        editable={props.editable}
        currentDay={currentDay}
        startTime={`${itemArray[i].fromHour}:${itemArray[i].fromMinute}`}
        endTime={`${itemArray[i].toHour}:${itemArray[i].toMinute}`}
        key={i}
        index={i}
        updateTime={updateTime}
        isClosed={itemArray[i].isClosed}
        day={itemArray[i].day}
      />
    )
  }
  currentDay !== currIndex && setCurrentDay(currIndex)
  return (
    <div
      className={classNames(
        styles.root,
        !props.editable ? styles['root--static'] : '',
        className || ''
      )}
    >
      {props.editable ? (
        <>
          <p className={styles.title}>
            <Translation span text={'businessHours-working-hours'} />
          </p>
          {result}
        </>
      ) : (
        <>
          <img className={styles.icon} src={imgClocks} alt="" />
          {result}
        </>
      )}
    </div>
  )
}

export default BusinessHours
